import { useContext } from 'react';
import { ProjectsContext, ProjectsContextProps } from '../context';

export const useProjectsContext: () => ProjectsContextProps = () => {
  const context = useContext(ProjectsContext);
  return context;
};

export default useProjectsContext;
